export default "__VITE_ASSET__BikiRwBG__"